"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowMoreButton = exports.ButtonSpacer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const fi_1 = require("react-icons/fi");
const VibescoutFrontendStyleConfig_1 = require("../config/VibescoutFrontendStyleConfig");
const FelaButton_1 = require("../fela/FelaButton");
const FelaFlexbox_1 = require("../fela/FelaFlexbox");
const FelaLayers_1 = require("../fela/FelaLayers");
const ButtonSpacer = ({ open }) => ((0, jsx_runtime_1.jsx)(FelaFlexbox_1.FelaFlexbox, { style: { height: open ? "3.5em" : undefined }, gridColumn: "1 / -1" }));
exports.ButtonSpacer = ButtonSpacer;
exports.ShowMoreButton = react_1.default.memo(({ buttonRef, onClick, isOpen }) => {
    return ((0, jsx_runtime_1.jsx)(FelaLayers_1.FelaFlexLayer, { zIndex: 1, extraSoftShadow: isOpen, rootProps: {
            ref: buttonRef,
        }, style: { pointerEvents: "all" }, backgroundOpacity: 0.8, height: VibescoutFrontendStyleConfig_1.ESurfaceHeight.high, gradient: isOpen
            ? undefined
            : [
                {
                    stops: [
                        {
                            neutral: VibescoutFrontendStyleConfig_1.EAppColor.accent,
                            opacity: isOpen ? 0.2 : 0,
                            def: isOpen ? "0" : "15%",
                        },
                        { neutral: VibescoutFrontendStyleConfig_1.EAppColor.accent, opacity: 0.5, def: isOpen ? "30%" : "51%" },
                        { height: VibescoutFrontendStyleConfig_1.ESurfaceHeight.high, opacity: 1, def: isOpen ? "31%" : "52%" },
                    ],
                },
                {
                    stops: [
                        { height: VibescoutFrontendStyleConfig_1.ESurfaceHeight.shadow, opacity: 0, def: "0%" },
                        { height: VibescoutFrontendStyleConfig_1.ESurfaceHeight.shadow, opacity: 0.5, def: "30%" },
                        { height: VibescoutFrontendStyleConfig_1.ESurfaceHeight.shadow, opacity: isOpen ? 0 : 1, def: "50%" },
                        { neutral: VibescoutFrontendStyleConfig_1.EAppColor.accent, opacity: isOpen ? 0 : 1, def: "51%" },
                    ],
                },
            ], 
        // shadow
        // extraSoftShadow
        padding: isOpen ? 0 : "2em 0 0 0", direction: "column", children: (0, jsx_runtime_1.jsxs)(FelaButton_1.FelaButton
        // margin={1}
        , { 
            // margin={1}
            margin: "0.75em 0.6em", size: FelaButton_1.EButtonSize.mainPageAction, neutralColor: VibescoutFrontendStyleConfig_1.EAppColor.accent, onClick: onClick, children: [isOpen ? (0, jsx_runtime_1.jsx)(fi_1.FiMinusCircle, {}) : (0, jsx_runtime_1.jsx)(fi_1.FiPlusCircle, {}), (0, jsx_runtime_1.jsx)("span", { children: isOpen ? "Show Less" : "Show More" })] }) }));
});
